import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { addBodyScrollLockingWhileMounted } from 'shared/src/utils/bodyScrollLocking'

import { Layout } from './Layout'
import { MODAL_Z_INDEX } from '../utils/zIndex'

const useStyles = createUseStyles({
  layoutContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: MODAL_Z_INDEX,
    paddingTop: 0,
    paddingBottom: 0,
  },
  container: {
    minHeight: '100dvh',
  },
})

interface Props {
  containerClassName?: string
}

export const Modal: FC<Props> = flowMax(
  addDisplayName('Modal'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addBodyScrollLockingWhileMounted,
  ({ children, classes, containerClassName }) => (
    <Layout mode="creator" className={classes.layoutContainer}>
      <div className={cx(classes.container, containerClassName)}>
        {children}
      </div>
    </Layout>
  )
)
